import api from "./api";
import { storageKey } from "./siteConfig";

export async function registerAdminPushNotifications() {
  if (typeof window === "undefined") return { ok: false, reason: "no_window" };

  const capacitor = window.Capacitor;
  if (!capacitor?.isNativePlatform?.()) return { ok: false, reason: "not_native" };

  let PushNotifications;
  try {
    ({ PushNotifications } = await import("@capacitor/push-notifications"));
  } catch {
    return { ok: false, reason: "plugin_missing" };
  }

  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== "granted") return { ok: false, reason: "permission_denied" };

  await PushNotifications.removeAllListeners();
  if (capacitor.getPlatform?.() === "android" && typeof PushNotifications.createChannel === "function") {
    await PushNotifications.createChannel({
      id: "support_messages",
      name: "Support messages",
      description: "Admin support chat alerts",
      importance: 5,
      visibility: 1,
      vibration: true,
      sound: "default",
    }).catch(() => {});
  }
  await PushNotifications.addListener("registration", async (token) => {
    const value = token?.value || "";
    if (!value) return;
    try {
      const deviceId = window.localStorage.getItem(storageKey("device_id")) || "";
      const { data } = await api.post(
        "/admin/support/push-token",
        {
          token: value,
          platform: capacitor.getPlatform?.() || "android",
          device_id: deviceId,
        },
        { skipMaintenance: true },
      );
      window.localStorage.setItem("admin_support_push_token_registered", "1");
      window.localStorage.setItem("admin_support_push_configured", data?.push_configured ? "1" : "0");
    } catch (error) {
      window.localStorage.setItem("admin_support_push_token_registered", "0");
      window.localStorage.setItem(
        "admin_support_push_error",
        String(error?.response?.data?.detail || error?.message || "registration_failed").slice(0, 300),
      );
    }
  });
  await PushNotifications.addListener("registrationError", (error) => {
    window.localStorage.setItem("admin_support_push_token_registered", "0");
    window.localStorage.setItem(
      "admin_support_push_error",
      String(error?.error || error?.message || "registration_error").slice(0, 300),
    );
  });
  await PushNotifications.addListener("pushNotificationActionPerformed", () => {
    window.location.assign("/admin/support-app");
  });
  await PushNotifications.addListener("pushNotificationReceived", () => {});
  await PushNotifications.register();
  return { ok: true, native: true };
}
